import { Bot, Search, Wrench } from 'lucide-react'
import type { Turn, TurnMode } from '../api/picassoApi'

export const MODE_LABEL: Record<TurnMode, string> = { search: 'Search', chat: 'Concierge', tool: 'Agent tool' }
export const MODE_ICON: Record<TurnMode, typeof Search> = { search: Search, chat: Bot, tool: Wrench }

/** The concierge's written answer, whichever field it arrived in. */
export function messageOf(turn: Turn): string {
  const r = turn.response
  if (!r) return ''
  return r.concierge?.message || (typeof r.message === 'string' ? r.message : '') || ''
}
